import { type SearchValues, useUpdateQueryParams } from '@pba/react-router';
import { useCallback, useMemo } from 'react';
import type { ChatroomsSearchParamsOptions, ChatroomsSearchParamsUpdates } from 'features/chat';
import { useChatroomsPageFilterParams } from './hooks';

export const useChatroomsSearchParams = (): ChatroomsSearchParamsOptions => {
  const { createFilterUrlUpdates, filter } = useChatroomsPageFilterParams();
  const updateQueryParams = useUpdateQueryParams();

  const updateSearchParams = useCallback(
    (updates: ChatroomsSearchParamsUpdates) => {
      const urlUpdates: SearchValues = {};

      if (updates.filter) {
        Object.assign(urlUpdates, createFilterUrlUpdates(updates.filter));
      }

      updateQueryParams({ navigateOptions: { replace: true }, urlUpdates });
    },
    [createFilterUrlUpdates, updateQueryParams],
  );

  return useMemo(
    () => ({
      filter,
      updateSearchParams,
    }),
    [filter, updateSearchParams],
  );
};
